import { render, staticRenderFns } from "./tpv-ma.vue?vue&type=template&id=482342ea&scoped=true"
import script from "./tpv-ma.vue?vue&type=script&lang=js"
export * from "./tpv-ma.vue?vue&type=script&lang=js"
import style0 from "./tpv-ma.vue?vue&type=style&index=0&id=482342ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482342ea",
  null
  
)

export default component.exports